import { Button, Card, Col, Form, Input, Row, Select, Typography } from "antd";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import styles from "./AddNewAccount.module.css";

import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { addAccount } from "../../redux/actions/account/addAccountAction";
import { getMainAccount } from "./account.api";

const AddAccount = ({ onSuccess = null, inModal = false, onCancel = null }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { Title } = Typography;

  const [form] = Form.useForm();
  const [loader, setLoader] = useState(false);
  const [accounts, setAccounts] = useState(null);

  const showCancel = Boolean(onCancel);

  useEffect(() => {
    const getAccounts = async () => {
      const response = await getMainAccount();
      setAccounts(response);
    };
    getAccounts();
  }, []);

  const onFinish = async (values) => {
    try {
      const resp = await dispatch(addAccount(values));
      if (resp === "success") {
        setLoader(false);
        toast.success("Account Added");
        form.resetFields();
        if (inModal && onSuccess) onSuccess();
      } else {
        setLoader(false);
      }
    } catch (error) {
      toast.error("Error in adding account");
      console.log(error.message);
      setLoader(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    setLoader(false);
  };

  const isLogged = Boolean(localStorage.getItem("isLogged"));
  if (!isLogged) {
    return <Navigate to={"/auth/login"} replace={true} />;
  }

  const formContent = (
    <Form
      form={form}
      name="basic"
      labelCol={{ span: inModal ? 6 : 7 }}
      labelWrap
      wrapperCol={{ span: inModal ? 18 : 16 }}
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >
      <Form.Item
        style={{ marginBottom: "10px" }}
        name="name"
        label="Name"
        rules={[{ required: true, message: "Please input account name!" }]}
      >
        <Input placeholder="Name" />
      </Form.Item>
      <Form.Item
        style={{ marginBottom: "10px" }}
        name="account_id"
        label="Account Type"
        rules={[{ required: true, message: "Please select account type!" }]}
      >
        <Select
          loading={!accounts}
          showSearch
          style={{ width: inModal ? "100%" : 200 }}
          placeholder="Select Account Type"
          optionFilterProp="children"
          filterOption={(input, option) => option?.children?.includes(input)}
          filterSort={(optionA, optionB) =>
            String(optionA?.children).toLowerCase().localeCompare(String(optionB?.children).toLowerCase())
          }
        >
          {accounts?.map((acc) => (
            <Select.Option key={acc.id} value={acc.id}>{acc.name}</Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        style={{ marginBottom: inModal ? 0 : "10px" }}
        className={!inModal ? styles.addNewAccountBtnContainer : undefined}
        wrapperCol={inModal ? { offset: 0, span: 24 } : undefined}
      >
        {inModal ? (
          <div style={{ display: "flex", justifyContent: "center", gap: 8, width: "100%" }}>
            <Button
              type="primary"
              htmlType="submit"
              shape="round"
              loading={loader}
              onClick={() => setLoader(true)}
              style={{
                backgroundColor: "#52c41a",
                borderColor: "#52c41a",
                color: "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
              block={!showCancel}
            >
              Add Account
            </Button>
            {onCancel && (
              <Button
                type="primary"
                danger
                shape="round"
                onClick={onCancel}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                Cancel
              </Button>
            )}
          </div>
        ) : (
          <Button
            type="primary"
            htmlType="submit"
            shape="round"
            loading={loader}
            onClick={() => setLoader(true)}
          >
            Add New Account
          </Button>
        )}
      </Form.Item>
    </Form>
  );

  if (inModal) return formContent;

  return (
    <div>
      <Row className="mr-top ">
        <Col xs={24} sm={24} md={24} lg={16} xl={12} className="border rounded column-design">
          <Card bordered={false}>
            <Title level={4} className="text-center" style={{ backgroundColor: '#dadada', padding: '10px', margin: '0 !important' }}>
              Add Account
            </Title>
            {formContent}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AddAccount;
